import React from 'react';
import './Experience.css';
import Arhant from '../../assets/aSolution.png';
import CFLogo from '../../assets/cf.jpeg';
import BrainDigit from '../../assets/braindigit.png';
import CStack from '../../assets/cstack.png';
import Rb from '../../assets/rb.png';

function Experience() {
    const experiences = [
        {
            title: 'Software Developer',
            company: 'SawariBooking',
            logo: Rb,
            style: { width: 120, height: 30, backgroundColor: 'white' },
            duration: 'Aug 2024 - Present',
            details: [
                'Developed a complete React Native mobile application from scratch for both iOS and Android.',
                'Published and maintained applications on the App Store and Google Play Store.',
                'Integrated multiple payment gateways, ensuring secure and seamless transactions.',
                'Contributed to web development using React.js and customized WordPress projects.'
            ],
        },
        {
            title: 'Software Developer',
            company: 'ConvergeStack',
            logo: CStack,
            style: { width: 120, height: 30 },
            duration: 'Dec 2022 - Aug 2024',
            details: [
                'Gained hands-on experience in backend Java development and RESTful API design.',
                'Implemented AWS Cloud services (Amplify, Cognito, Lambda, CloudFront, S3) to build scalable infrastructure.',
                'Developed and maintained React Native mobile applications for iOS and Android.',
                'Explored modern web technologies like React.js and Vue.js for dynamic front-end interfaces.'
            ],
        },
        {
            title: 'Dot Net Developer',
            company: 'Arhant Solutions',
            logo: Arhant,
            style: { width: 80, height: 40 },
            duration: 'Dec 2021 - Dec 2022',
            details: [
                'Designed, developed, tested, and maintained RESTful APIs using C#, ASP.NET, and SQL Server.',
                'Deployed applications across multiple servers, ensuring stable production performance.',
                'Created comprehensive technical documentation for API specifications and deployment.',
                'Gained experience with jQuery for front-end interactivity.'
            ],
        },
        {
            title: 'Dot Net Internship',
            company: 'Braindigit',
            logo: BrainDigit,
            style: { width: 100, height: 40, backgroundColor: 'white' },
            duration: 'Jun 2021 - Aug 2021',
            details: [
                'Contributed to backend and API development on a real-world .NET project.',
                'Designed, implemented, and tested RESTful APIs to support data exchange.',
                'Applied security practices including authentication and data protection mechanisms.'
            ],
        },
        {
            title: 'Data Annotator',
            company: 'CloudFactory',
            logo: CFLogo,
            style: { height: 60 },
            duration: 'Mar 2018 - June 2021',
            details: [
                'Responsible for detailed data annotation and completeness using internal tools.',
                'Prepared high-quality datasets for computer vision model training (Neurala project).',
                'Ensured accuracy and consistency of annotated data to improve neural network reliability.'
            ],
        },
    ];

    return (
        <div className="experience">
            <h1 className="section-title">Career Journey</h1>
            <div className="timeline-container">
                {experiences.map((exp, index) => (
                    <div key={index} className="timeline-item">
                        <div className="timeline-dot"></div>
                        <div className="timeline-content">
                            <div className="timeline-header">
                                <div className="timeline-logo-wrapper">
                                    <img src={exp.logo} alt={exp.company} className="timeline-logo" style={exp.style} />
                                </div>
                                <div className="timeline-titles">
                                    <h3>{exp.title}</h3>
                                    <span className="company-name">{exp.company}</span>
                                    <span className="timeline-duration">{exp.duration}</span>
                                </div>
                            </div>
                            <ul className="timeline-details">
                                {exp.details.map((detail, idx) => (
                                    <li key={idx}>
                                        <span className="bullet"></span>
                                        {detail}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Experience;
